import { ACCESS_TOKEN_STORAGE_KEY, useAuthStore } from "@/stores/auth";
import ky from "ky";
import { toast } from "vue-sonner";
import * as Sentry from "@sentry/vue";

// create a ky instance
const API_URL = "/api";
const client = ky.extend({
  prefixUrl: API_URL,
  hooks: {
    beforeRequest: [
      (request) => {
        const token = localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY);
        request.headers.set("Authorization", `Bearer ${token}`);
      },
    ],
    beforeError: [
      async (error) => {
        const { response, request } = error;
        // send error to sentry
        if (Sentry.isInitialized()) {
          // log request data as well
          Sentry.logger.debug(`API Request failed for url ${request.url}`, {
            request: {
              body: await request.json().catch(() => request.text()),
              url: request.url,
              method: request.method,
              status: response?.status,
            },
            response: response ? {
              status: response.status,
              body: await response.json().catch(() => response.text()),
            } : null,
            log_source: "api_client",
          });
          Sentry.captureException(error);
        }
        if (response) {
          try {
            const body = await response.json<any>();
            // validation error
            if (body.errors && body.errors.length > 0) {
              error.message = body.errors[0].message;
            } else {
              error.message = body.error_message ?? error.message;
            }
          } catch {
            // ignore
          }
        }
        return error;
      },
    ],
    afterResponse: [
      async (_, __, response) => {
        if (response.status === 401) {
          const authStore = useAuthStore();
          if (authStore.isAuthenticated) {
            toast.error("Session expired. Please login again.");
          }
          authStore.reset();
        }
        return response;
      },
    ],
  },
});

export default client;
